import { formatFullDateAndTime } from "~/utils/datetime";
import { toDbId } from "~/utils/graphql-helpers";
import type { BulkUploadRowData } from "./bulkUploadGraphqlDataSource";
import type { ITooltipParams, ValueGetterParams } from "ag-grid-community";

export function getJobIdValue(params: ValueGetterParams<BulkUploadRowData>): string {
  const id = params.data?.id;
  if (!id) return "-";
  return String(toDbId(id));
}

export function getSuccessfulRowsValue(params: ValueGetterParams<BulkUploadRowData>): string {
  return String(params.data?.data?.successful_rows ?? "-");
}

export function getTotalRowsValue(params: ValueGetterParams<BulkUploadRowData>): string {
  return String(params.data?.data?.total_rows ?? "-");
}

export function getCreatedAtValue(params: ValueGetterParams<BulkUploadRowData>): string {
  const createdAt = params.data?.createdAt;
  if (!createdAt) return "-";
  return formatFullDateAndTime(createdAt, "MM/dd/yyyy h:mm a");
}

export function getDetailsTooltip(params: ITooltipParams<BulkUploadRowData>): string | null {
  return params.data?.data?.errors?.[0] ?? null;
}
